import CN from "classnames";
import { styled } from "@mui/material/styles";

const apiKey = process.env.GOOGLE_CLOUD_API_KEY as string;
export const GoogleMapsSinglePlaceEmbed = ({
  address = "",
  zoom = "",
  title,
  isFullSize = false,
  placeId,
  ...propsToIframe
}: React.IframeHTMLAttributes<HTMLIFrameElement> & {
  className?: string;
  address: string;
  placeId?: string;
  zoom: number | string;
  title?: string;
  // Requires the parent to have `position: relative`.
  isFullSize?: boolean;
}) => (
  <GoogleMapsIframe
    className={CN("GoogleMapsEmbed")}
    title={title}
    frameBorder="0"
    src={`https://www.google.com/maps/embed/v1/place?q=${
      placeId ? `place_id:${placeId}` : encodeURIComponent(address)
    }&key=${apiKey}&zoom=${zoom}`}
    allowFullScreen
    {...(isFullSize
      ? {
          width: "100%",
          height: "100%",
          style: { position: "absolute", width: "100%", height: "100%" },
        }
      : {})}
    {...propsToIframe}
  />
);

const GoogleMapsIframe = styled("iframe")`
  width: 100%;
  min-height: 200px;
`;
